import { Component, HostListener, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { TranslateService } from '@ngx-translate/core';
import { MenuService } from './services/menu.service';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';



@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppHeaderComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent  implements  OnInit {


  isMenuOpen$: Observable<boolean>;

  constructor(//private authService: AuthService
  private translate: TranslateService,
  private menuService: MenuService) {
    this.translate.addLangs(['en', 'he']);
    this.translate.setDefaultLang('he');
    this.isMenuOpen$ = this.menuService.isMenuOpen$;
  }

  currentYear = new Date().getFullYear();   

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  ngOnInit(): void {
    // Check screen size and set menu state accordingly
    this.checkScreenSize();
    window.addEventListener('resize', () => this.checkScreenSize());
  
  }

  checkScreenSize(): void {
    this.menuService.checkScreenSize(); // Keep menu open on larger screens
  }

  toggleMenu(): void {
    this.menuService.toggleMenu();
  }  
}